import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // 👈 this reads the .env variable
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;